import { render } from "./TopCoverCompanies.vue?vue&type=template&id=09f0104c&scoped=true&ts=true"
import script from "./TopCoverCompanies.vue?vue&type=script&lang=ts"
export * from "./TopCoverCompanies.vue?vue&type=script&lang=ts"

import "./TopCoverCompanies.vue?vue&type=style&index=0&id=09f0104c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f0104c"]])

export default __exports__